<template>
  <navigation
    v-bind:sub_components_list="subComponentsList"
    v-bind:labels="labels"
    v-bind:default_key="'campagnes'"
    v-bind:sync_with_route="true" />
</template>

<script setup lang="ts">
  import navigation from '@/views/_espace/_refonte/formateur/utils/navigation.vue';

  import campagnes from '@/views/_espace/_formateur/_appreciations/campagnes.vue';
  import formations from '@/views/_espace/_formateur/_appreciations/formations.vue';
  import sessions from '@/views/_espace/_formateur/_appreciations/sessions.vue';

  const labels: Record<string, string> = {
    campagnes: 'Par campagne',
    formations: 'Par formation',
    sessions: 'Par session'
  };

  const subComponentsList = {
    campagnes,
    formations,
    sessions
  };
</script>

<style lang="scss" scoped></style>
